import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeResidence } from 'shell/models/type-payment';
import { ModalityPaymentVM } from 'shell/view-models/modality-payment';

export const transformerModalityPayment = (
  response: AxiosResponse<HttpResponseList<TypeResidence>>
): Array<ModalityPaymentVM> => {
  const { data } = response;

  return data?.payload.list.map((item) => ({
    id: item.key.codiceModalitaRilascio,
    value: item.descrizione,
    amountTaxStamp: item.importoImpostaBollo ? Number.parseFloat(item.importoImpostaBollo) : 0,
    amountRightsSecretariat: item.importoDirittiSegreteria
      ? Number.parseFloat(item.importoDirittiSegreteria)
      : 0,
    amountRightsCivilState: item.importoDirittiStatoCivile
      ? Number.parseFloat(item.importoDirittiStatoCivile)
      : 0,
    amountFixedRights: item.importoDirittiFissi ? Number.parseFloat(item.importoDirittiFissi) : 0,
    amountExpenses: item.importoSpese ? Number.parseFloat(item.importoSpese) : 0,
    codeExemptionAnpr: item.codiceEsenzioneAnpr,
    registryType: item.tipoRegistro,
    descrizioneModalitaStampa: item.descrizioneModalitaStampa,
    item,
  })) as Array<ModalityPaymentVM>;
};
